module.exports = __webpack_public_path__ + "img/caret-down.ca82bc74.svg";